import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { OrderConfirmIframe } from './styled';
import { StatusTypes, stringify } from '@chegg/commerce-utils';
export var OrderConfirmationIframe = function OrderConfirmationIframe(_ref) {
  var cheggBaseUrl = _ref.cheggBaseUrl,
    token = _ref.token,
    checkoutFlowType = _ref.checkoutFlowType,
    conversionType = _ref.conversionType,
    productFamily = _ref.productFamily,
    productId = _ref.productId,
    couponCode = _ref.redemptionCode,
    zipCode = _ref.zipCode,
    flow = _ref.flow,
    partnerName = _ref.partnerName,
    blockDDRW = _ref.blockDDRW,
    callback = _ref.callback;
  var orderPixelData = _objectSpread({
    token: token,
    checkoutFlowType: checkoutFlowType,
    conversionType: conversionType,
    productType: productFamily,
    productId: productId,
    couponCode: couponCode,
    zipCode: zipCode,
    flow: flow,
    partnerName: partnerName
  }, blockDDRW && {
    blockDDRW: '1'
  });
  var qs = stringify(JSON.parse(JSON.stringify(orderPixelData)));

  // dedupe '/' when required
  var sanitizedBaseUrl = cheggBaseUrl.endsWith('/') ? cheggBaseUrl.slice(0, cheggBaseUrl.length - 1) : cheggBaseUrl;
  var src = "".concat(sanitizedBaseUrl, "/order-confirmation-pixel?").concat(qs); // formerly `${cheggBaseUrl}/orderconfirmpixel?${qs}`

  var fireCallback = function fireCallback() {
    callback && callback({
      status: StatusTypes.SUCCESS,
      payload: {
        data: {
          ocpIframeLoaded: true
        }
      }
    });
  };
  return /*#__PURE__*/React.createElement(OrderConfirmIframe, {
    "data-test": 'CONFIRMATION_PIXEL_IFRAME',
    src: src,
    id: 'orderconfirmpixel',
    className: 'pixel',
    width: '1',
    height: '1',
    title: 'adobeConfirmation',
    onLoad: fireCallback,
    "aria-hidden": true
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/order-confirmation/dist/esm/components/OrderConfirmationIframe/index.js
// module id = 4196
// module chunks = 11